import {
  TextField,
  Box,
  Checkbox,
  FormLabel,
  useTheme,
  Typography,
  Button,
  IconButton,
  Tooltip,
  Breadcrumbs,
  LinearProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  FormControlLabel,
  FormControl,
  MenuItem,
  InputLabel,
  Select,
  List,
  ListSubheader,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
  Divider,
} from "@mui/material";
import dayjs from "dayjs";
import {
  dataGridHeaderFooterHeight,
  dataGridHeight,
  dataGridRowHeight,
  formGap,
} from "../../../ui-components/global/utils";
import axios from "axios";
import { nanoid } from "@reduxjs/toolkit";
import store from "../../..";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import useMediaQuery from "@mui/material/useMediaQuery";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import { useParams, useNavigate, useLocation } from "react-router-dom";

import { ArrowDropDownIcon } from "@mui/x-date-pickers";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-hot-toast";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import FileListPopup from "../../../ui-components/FIleViewDialog";
import FileUploadIconButton from "../../../ui-components/FileUploadButton";
import AddIcon from "@mui/icons-material/Add";
import { attachmentPost } from "../../../store/reducers/LoginReducer";
import GradingIcon from "@mui/icons-material/Grading";
import {
  getFetchData,
  postData,
  RoutineHeaderGetData,
  sprintGetData,
  sprintprojectplanGetData,
} from "../../../store/reducers/Formapireducer";
import React, { useState, useEffect, useRef, useMemo } from "react";
import { LoadingButton } from "@mui/lab";
import Swal from "sweetalert2";
import { useProSidebar } from "react-pro-sidebar";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import { tokens } from "../../../Theme";
import {
  DataGrid,
  GridToolbarContainer,
  GridActionsCellItem,
  GridRowModes,
  GridRowEditStopReasons,
} from "@mui/x-data-grid";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Productautocomplete,
  SprintEmpAutocomplete,
} from "../../../ui-components/global/Autocomplete";
import { Formik, Field } from "formik";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Mode } from "@mui/icons-material";
import { fetchExplorelitview } from "../../../store/reducers/Explorelitviewapireducer";
import ErrorMsgData from "../../Security/validationMsg.json"
import * as Yup from "yup";
const EditRoutine = (empId, appId) => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  let params = useParams();
  console.log(params, "--params");
  const exploreLoading = useSelector((state) => state.exploreApi.loading);
  const dispatch = useDispatch();
  var recID = params.id;
  var mode = params.Mode;
  const getLoading = useSelector((state) => state.formApi.routineloading);
  const RoutineGEtdata = useSelector((state) => state.formApi.routineget) || {};
  console.log("🚀 ~ EditRoutine ~ RoutineGEtdata:", RoutineGEtdata);
  const routinePPget = useSelector((state) => state.formApi.routinePPget) || {};
  const listViewurl = useSelector((state) => state.globalurl.listViewurl);
  const sprintPPgetloading = useSelector(
    (state) => state.formApi.sprintloading
  );
  const CompanyAutoCode = sessionStorage.getItem("CompanyAutoCode");
  console.log(CompanyAutoCode, "CompanyAutoCode");
  const YearFlag = sessionStorage.getItem("YearFlag");
  const { toggleSidebar, broken, rtl } = useProSidebar();
  const CompanyID = sessionStorage.getItem("companyId");
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const rowSx = { height: 36, "& td, & th": { py: 0.5 } };
  console.log("🚀 ~ EditSprint ~ CompanyID:", CompanyID);
  const EMPID = sessionStorage.getItem("EmpId");
  const location = useLocation();
  const state = location.state || {};
  const [pageSize, setPageSize] = React.useState(10);
  console.log("🚀 ~ EditSprint ~ state:", state);
  const theme = useTheme();
  var accessID = params.accessID;
  const colors = tokens(theme.palette.mode);
  const [selectedConfig, setSelectedConfig] = useState("D");
  const [checkboxData, setCheckboxData] = useState({});
  const [configRowCount, setConfigRowCount] = useState(0);
  const [subtaskRowCount, setSubtaskRowCount] = useState(0);
  const [errorMsgData, setErrorMsgData] = useState(null);
  const [validationSchema, setValidationSchema] = useState(null);

  useEffect(() => {
    fetch(process.env.PUBLIC_URL + "/validationcms.json")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch validationcms.json");
        return res.json();
      })
      .then((data) => {
        setErrorMsgData(data);

        let schemaFields = {
          Comment: Yup.string().trim().required(data.Routinetask.Comment),
        };

        if (CompanyAutoCode === "N") {
          schemaFields.code = Yup.string().required(data.Routinetask.code);
        }

        const schema = Yup.object().shape(schemaFields);
        setValidationSchema(schema);
      })
      .catch((err) => console.error("Error loading validationcms.json:", err));
  }, [CompanyAutoCode]);

  useEffect(() => {
    // dispatch(RoutineHeaderGetData({ accessID, get: "get", recID }));
    GetSprintData();
  }, [location.key]);
  const [rows, setRows] = useState([]);

  async function GetSprintData() {
    const data = await dispatch(
      RoutineHeaderGetData({ accessID, get: "get", recID })
    );
    if (data.payload.Status == "Y") {
      const resData = data.payload.Data.detailData.map((value) => {
        return {
          ...value,
          DesignationID: {
            RecordID: value.DesignationID,
            Name: value.DesignationName,
          },
        };
      });
      setRows(resData);
    } else {
      setRows([]); // Ensures rows don't break if explorelistViewData is undefined or not an array
    }
  }
  // *************** INITIALVALUE  *************** //
  const [rowModesModel, setRowModesModel] = useState({});
  const [open, setOpen] = useState(false);
  useState(null);
  function EditToolbar(props) {
    const { setRows, setRowModesModel } = props;

    const handleClick = () => {
      const id = nanoid();
      const nextSLNO =
        rows.length > 0 ? Math.max(...rows.map((row) => row.SLNO || 0)) + 1 : 1;
      setRows((oldRows) => [
        ...oldRows,
        {
          SLNO: nextSLNO,
          RoutineDetailID: id,
          RoutineDetailCode: "",
          RoutineDetailName: "",
          DetailRthID: "",
          DesignationID: null,
          DesignationName: "",
          Effort: 0,
          Unit: "",
          isNew: true,
        },
      ]);
      setRowModesModel((oldModel) => ({
        ...oldModel,
        [id]: { mode: GridRowModes.Edit, fieldToFocus: "RoutineDetailID" },
      }));
    };
    return (
      <GridToolbarContainer
        sx={{
          marginBottom: "5px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexDirection: "row",
        }}
      >
        <Typography>List of Tasks</Typography>
        <Button color="primary" startIcon={<AddIcon />} onClick={handleClick}>
          Add Record
        </Button>
      </GridToolbarContainer>
    );
  }

  const handleCheckboxChange = (key) => {
    setCheckboxData((prev) => ({
      ...prev,
      [key]: !prev[key], // toggle the value (true/false)
    }));
  };
  const handleRowEditStop = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };

  const handleEditClick = (RecordID) => () => {
    setRowModesModel({
      ...rowModesModel,
      [RecordID]: { mode: GridRowModes.Edit },
    });
  };

  const handleSaveClick = (RoutineDetailID) => () => {
    setRowModesModel({
      ...rowModesModel,
      [RoutineDetailID]: { mode: GridRowModes.View },
    });
  };

  const handleDeleteClick = (RoutineDetailID) => async (values, action) => {
    setRows(rows.filter((row) => row.RoutineDetailID !== RoutineDetailID));


    toast.success("Deleted Successfully");

  };

  const handleCancelClick = (RecordID) => () => {
    setRowModesModel({
      ...rowModesModel,
      [RecordID]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow = rows.find((row) => row.RecordID === RecordID);
    if (editedRow.isNew) {
      setRows(rows.filter((row) => row.RecordID !== RecordID));
    }
  };

  const processRowUpdate = (newRow, oldRow) => {
    const isNew = !oldRow?.RoutineDetailID;
    const updatedRow = { ...newRow, isNew };

    setRows((prev) => {
      const index = prev.findIndex(
        (row) => row.RoutineDetailID === updatedRow.RoutineDetailID
      );
      if (index !== -1) {
        const newData = [...prev];
        newData[index] = updatedRow;
        return newData;
      }
      return [...prev, updatedRow];
    });
    // setSelectedRoleOptions(null);
    // setRoleid("");
    // setRoleName("");

    // handleSave(updatedRow.RecordID, params, funMode);

    return updatedRow;
  };
  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  const handleInsert = () => {
    const newId = nanoid(); // Temporary unique ID
    setRows((prevRows) => {
      const nextSLNO =
        prevRows.length > 0
          ? Math.max(...prevRows.map((row) => row.SLNO || 0)) + 1
          : 1; // Determine next SLNO

      const newRow = {
        SLNO: nextSLNO,
        RoutineDetailID: newId,
        RoutineDetailCode: "",
        RoutineDetailName: "",
        DetailRthID: "",
        DesignationID: 0,
        DesignationName: "",
        Effort: 0,
        Unit: "",
        isNew: true,
      };

      return [...prevRows, newRow]; // Append the new row to the existing rows
    });

    console.log("----step3 setRowModesModel initializing Objects");
    setRowModesModel((prev) => ({
      ...prev,
      [newId]: { mode: GridRowModes.Edit },
    }));
  };
  const handleInsertInrow = (recordID) => {
    const newId = nanoid(); // Temporary unique ID

    setRows((prevRows) => {
      const index = prevRows.findIndex(
        (row) => row.RoutineDetailID === recordID
      ); // ✅ Find the clicked row's index

      if (index === -1) return prevRows; // If not found, return unchanged rows

      const nextSLNO =
        prevRows.length > 0
          ? Math.max(...prevRows.map((row) => row.SLNO || 0)) + 1
          : 1;

      const newRow = {
        SLNO: nextSLNO,
        //RecordID: newId,
        RoutineDetailID: newId,
        RoutineDetailCode: "",
        RoutineDetailName: "",
        DetailRthID: "",
        DesignationID: 0,
        DesignationName: "",
        Effort: 0,
        Unit: "",
        isNew: true,
      };

      const updatedRows = [...prevRows];
      updatedRows.splice(index + 1, 0, newRow); // ✅ Insert row at the correct position

      return updatedRows;
    });

    setRowModesModel((prev) => ({
      ...prev,
      [newId]: { mode: GridRowModes.Edit },
    }));
  };
  function EditAutocompleteCell(props) {
    const { id, value, field, api, row } = props;

    const handleChange = async (newValue) => {
      setRole(newValue);
      await api.setEditCellValue({
        id,
        field: "DesignationID",
        value: newValue,
      });

      api.stopCellEditMode({ id, field });
    };
    const [role, setRole] = useState(
      row.DesignationID ? row.DesignationID : null
    );
    return (
      <SprintEmpAutocomplete
        name="DesignationID"
        label="Role Name"
        id="DesignationID"
        value={role}
        onChange={handleChange}
        url={`${listViewurl}?data={"Query":{"AccessID":"2047","ScreenName":"Role","Filter":"parentID=${CompanyID}","Any":""}}`}
      />
    );
  }
  const columns = [
    // { field: "SLNO", headerName: "SL#", width: 70 },
    {
      field: "slno",
      headerName: "SL#",
      width: 50,
      sortable: false,
      filterable: false,
      valueGetter: (params) =>
        `${params.api.getRowIndexRelativeToVisibleRows(params.id) + 1}`
    },
    {
      headerName: "RoutineDetailCode",
      field: "RoutineDetailCode",
      width: "100",
      align: "left",
      headerAlign: "center",
      hide: true,
    },
    {
      headerName: "Description",
      field: "RoutineDetailName",
      width: "200",
      align: "left",
      headerAlign: "center",
      hide: false,
      editable: "true",
    },
    {
      headerName: "DetailRthID",
      field: "DetailRthID",
      width: "100",
      align: "right",
      headerAlign: "center",
      hide: true,
    },
    {
      headerName: "CompanyID",
      field: "CompanyID",
      width: "100",
      align: "left",
      headerAlign: "center",
      hide: true,
    },
    {
      headerName: (
        <span>
          Role <span style={{ color: "red" }}>*</span>
        </span>
      ),
      field: "DesignationID",
      width: 300,
      headerAlign: "center",
      hide: false,
      editable: true,
      sortable: false,
      renderCell: (params) => {
        return params.value?.Name || ""; // show only the name
      },
      renderEditCell: (params) => {
        return <EditAutocompleteCell {...params} />;
      },
    },
    {
      field: "Effort",
      headerName: "Effort",
      width: 150,
      headerAlign: "center",
      editable: true,
      type: "number",
    },
    {
      field: "Unit",
      headerName: "Unit",
      width: 200,
      align: "left",
      headerAlign: "center",
      editable: true,
      type: "singleSelect",
      valueOptions: ["Hours", "Days", "Month"],
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 150,
      cellClassName: "actions",
      getActions: ({ id }) => {
        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;

        if (isInEditMode) {
          return [
            <GridActionsCellItem
              icon={<SaveIcon />}
              label="Save"
              material={{
                sx: {
                  color: "primary.main",
                },
              }}
              onClick={handleSaveClick(id)}
            />,
            <GridActionsCellItem
              icon={<CancelIcon />}
              label="Cancel"
              className="textPrimary"
              onClick={handleCancelClick(id)}
              color="inherit"
            />,
          ];
        }

        return [
          <GridActionsCellItem
            icon={<AddIcon style={{ color: "#00563B" }} />}
            label="Add"
            onClick={() => handleInsertInrow(id)}
            color="inherit"
          />,
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            className="textPrimary"
            onClick={handleEditClick(id)}
            color="inherit"
          />,
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            onClick={handleDeleteClick(id)}
            color="inherit"
          />,
        ];
      },
    },
  ];

  const toggleSection = (section) => {
    setOpenSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };
  const [openSections, setOpenSections] = useState({
    Daily: true,
    Weekly: true,
    Monthly: true,
  });

  // const dailyItems = {
  //   midnight: "00:00",
  //   oneAM: "01:00",
  //   twoAM: "02:00",
  //   threeAM: "03:00",
  //   fourAM: "04:00",
  //   fiveAM: "05:00",
  //   sixAM: "06:00",
  //   sevenAM: "07:00",
  //   eightAM: "08:00",
  //   nineAM: "09:00",
  //   tenAM: "10:00",
  //   elevenAM: "11:00",
  //   noon: "12:00",
  //   onePM: "13:00",
  //   twoPM: "14:00",
  //   threePM: "15:00",
  //   fourPM: "16:00",
  //   fivePM: "17:00",
  //   sixPM: "18:00",
  //   sevenPM: "19:00",
  //   eightPM: "20:00",
  //   ninePM: "21:00",
  //   tenPM: "22:00",
  //   elevenPM: "23:00",
  // };
  // const weeklyItems = {
  //   sunday: "Sunday",
  //   monday: "Monday",
  //   tuesday: "Tuesday",
  //   wednesday: "Wednesday",
  //   thursday: "Thursday",
  //   friday: "Friday",
  //   saturday: "Saturday",
  // };
  // const monthlyItems = {
  //   day1: "Day 1",
  //   day2: "Day 2",
  //   day3: "Day 3",
  //   day4: "Day 4",
  //   day5: "Day 5",
  //   day6: "Day 6",
  //   day7: "Day 7",
  //   day8: "Day 8",
  //   day9: "Day 9",
  //   day10: "Day 10",
  //   day11: "Day 11",
  //   day12: "Day 12",
  //   day13: "Day 13",
  //   day14: "Day 14",
  //   day15: "Day 15",
  //   day16: "Day 16",
  //   day17: "Day 17",
  //   day18: "Day 18",
  //   day19: "Day 19",
  //   day20: "Day 20",
  //   day21: "Day 21",
  //   day22: "Day 22",
  //   day23: "Day 23",
  //   day24: "Day 24",
  //   day25: "Day 25",
  //   day26: "Day 26",
  //   day27: "Day 27",
  //   day28: "Day 28",
  //   day29: "Day 29",
  //   day30: "Day 30",
  //   day31: "Day 31",
  // };

  const InitialValue = {
    code: RoutineGEtdata.RthCode,
    name: RoutineGEtdata.RthName,
    Milestone: RoutineGEtdata.MilestoneID
      ? {
        RecordID: RoutineGEtdata.MilestoneID,
        Name: RoutineGEtdata.MilestoneName,
      }
      : "",
    OperationStage: RoutineGEtdata.OperationStageID
      ? {
        RecordID: RoutineGEtdata.OperationStageID,
        Name: RoutineGEtdata.OperationStage,
      }
      : null,
    Activities: RoutineGEtdata.ActivitesID
      ? {
        RecordID: RoutineGEtdata.ActivitesID,
        Name: RoutineGEtdata.Activites,
      }
      : null,

    fromdate: RoutineGEtdata.FromDate,
    todate: RoutineGEtdata.ToDate,
    RoutineType: mode == "A" ? "Daily" : RoutineGEtdata.RoutineType,
    checkbox1: Boolean(RoutineGEtdata.Weekoff),
    checkbox2: Boolean(RoutineGEtdata.Holiday),
    Comment: RoutineGEtdata.Comments,
    Hourse1: Boolean(routinePPget?.Hour1),
    Hourse2: Boolean(routinePPget?.Hour2),
    Hourse3: Boolean(routinePPget?.Hour3),
    Hourse4: Boolean(routinePPget?.Hour4),
    Hourse5: Boolean(routinePPget?.Hour5),
    Hourse6: Boolean(routinePPget?.Hour6),
    Hourse7: Boolean(routinePPget?.Hour7),
    Hourse8: Boolean(routinePPget?.Hour8),
    Hourse9: Boolean(routinePPget?.Hour9),
    Hourse10: Boolean(routinePPget?.Hour10),
    Hourse11: Boolean(routinePPget?.Hour11),
    Hourse12: Boolean(routinePPget?.Hour12),
    Hourse13: Boolean(routinePPget?.Hour13),
    Hourse14: Boolean(routinePPget?.Hour14),
    Hourse15: Boolean(routinePPget?.Hour15),
    Hourse16: Boolean(routinePPget?.Hour16),
    Hourse17: Boolean(routinePPget?.Hour17),
    Hourse18: Boolean(routinePPget?.Hour18),
    Hourse19: Boolean(routinePPget?.Hour19),
    Hourse20: Boolean(routinePPget?.Hour20),
    Hourse21: Boolean(routinePPget?.Hour21),
    Hourse22: Boolean(routinePPget?.Hour22),
    Hourse23: Boolean(routinePPget?.Hour23),
    Hourse24: Boolean(routinePPget?.Hour24),
    WeekDay1: Boolean(routinePPget?.WeekDay1),
    WeekDay2: Boolean(routinePPget?.WeekDay2),
    WeekDay3: Boolean(routinePPget?.WeekDay3),
    WeekDay4: Boolean(routinePPget?.WeekDay4),
    WeekDay5: Boolean(routinePPget?.WeekDay5),
    WeekDay6: Boolean(routinePPget?.WeekDay6),
    WeekDay7: Boolean(routinePPget?.WeekDay7),
    MonthDay1: Boolean(routinePPget?.MonthDay1),
    MonthDay2: Boolean(routinePPget?.MonthDay2),
    MonthDay3: Boolean(routinePPget?.MonthDay3),
    MonthDay4: Boolean(routinePPget?.MonthDay4),
    MonthDay5: Boolean(routinePPget?.MonthDay5),
    MonthDay6: Boolean(routinePPget?.MonthDay6),
    MonthDay7: Boolean(routinePPget?.MonthDay7),
    MonthDay8: Boolean(routinePPget?.MonthDay8),
    MonthDay9: Boolean(routinePPget?.MonthDay9),
    MonthDay10: Boolean(routinePPget?.MonthDay10),
    MonthDay11: Boolean(routinePPget?.MonthDay11),
    MonthDay12: Boolean(routinePPget?.MonthDay12),
    MonthDay13: Boolean(routinePPget?.MonthDay13),
    MonthDay14: Boolean(routinePPget?.MonthDay14),
    MonthDay15: Boolean(routinePPget?.MonthDay15),
    MonthDay16: Boolean(routinePPget?.MonthDay16),
    MonthDay17: Boolean(routinePPget?.MonthDay17),
    MonthDay18: Boolean(routinePPget?.MonthDay18),
    MonthDay19: Boolean(routinePPget?.MonthDay19),
    MonthDay20: Boolean(routinePPget?.MonthDay20),
    MonthDay21: Boolean(routinePPget?.MonthDay21),
    MonthDay22: Boolean(routinePPget?.MonthDay22),
    MonthDay23: Boolean(routinePPget?.MonthDay23),
    MonthDay24: Boolean(routinePPget?.MonthDay24),
    MonthDay25: Boolean(routinePPget?.MonthDay25),
    MonthDay26: Boolean(routinePPget?.MonthDay26),
    MonthDay27: Boolean(routinePPget?.MonthDay27),
    MonthDay28: Boolean(routinePPget?.MonthDay28),
    MonthDay29: Boolean(routinePPget?.MonthDay29),
    MonthDay30: Boolean(routinePPget?.MonthDay30),
    MonthDay31: Boolean(routinePPget?.MonthDay31),
  };

  const handleSaveButtonClick = async (values, action) => {
    console.log("🚀 ~ handleSaveButtonClick ~ values:", values);
    var isCheck = "N";
    if (values.checkbox == true) {
      isCheck = "Y";
    }

    const idata = {
      RecordID: recID,
      RthCode: values.code,
      RthName: values.name,
      MilestoneID: values.Milestone ? values.Milestone.RecordID : 0,
      MilestoneName: values.Milestone ? values.Milestone.Name : 0,
      OperationStageID: values.OperationStage
        ? values.OperationStage.RecordID
        : 0,
      OperationStage: values.OperationStage ? values.OperationStage.Name : 0,
      ActivitesID: values.Activities ? values.Activities.RecordID : 0,
      Activites: values.Activities ? values.Activities.Name : 0,
      Disable: "Y",
      Sortorder: "1",
      FromDate: values.fromdate,
      ToDate: values.todate,
      ProjectID: params.filtertype,
      LoginUser: EMPID,
      Comments: values.Comment,
      Weekoff: Number(values.checkbox1),
      Holiday: Number(values.checkbox2),
      RoutineType: values.RoutineType,

      //RotinetaskHeaderID:,

      Details:
        rows.map((row, index) => ({
          RoutineDetailID: row.RoutineDetailID || "",
          RoutineDetailCode: row.RoutineDetailCode || "",
          Effort: row.Effort || "",
          RoutineDetailName: row.RoutineDetailName || "",
          DesignationName: row?.DesignationID?.Name || "",
          DesignationID: row?.DesignationID?.RecordID || "",
          DetailRthID: row.RecordID || "",
          Unit: row.Unit || "",
        })) || [],
      configsData: {
        RoutineConfigID: routinePPget.RoutineConfiguration,
        //RotinetaskHeaderID: routinePPget.RotinetaskHeaderID,
        Hourse1: Number(values.Hourse1),
        Hourse2: Number(values.Hourse2),
        Hourse3: Number(values.Hourse3),
        Hourse4: Number(values.Hourse4),
        Hourse5: Number(values.Hourse5),
        Hourse6: Number(values.Hourse6),
        Hourse7: Number(values.Hourse7),
        Hourse8: Number(values.Hourse8),
        Hourse9: Number(values.Hourse9),
        Hourse10: Number(values.Hourse10),
        Hourse11: Number(values.Hourse11),
        Hourse12: Number(values.Hourse12),
        Hourse13: Number(values.Hourse13),
        Hourse14: Number(values.Hourse14),
        Hourse15: Number(values.Hourse15),
        Hourse16: Number(values.Hourse16),
        Hourse17: Number(values.Hourse17),
        Hourse18: Number(values.Hourse18),
        Hourse19: Number(values.Hourse19),
        Hourse20: Number(values.Hourse20),
        Hourse21: Number(values.Hourse21),
        Hourse22: Number(values.Hourse22),
        Hourse23: Number(values.Hourse23),
        Hourse24: Number(values.Hourse24),
        WeekDay1: Number(values.WeekDay1),
        WeekDay2: Number(values.WeekDay2),
        WeekDay3: Number(values.WeekDay3),
        WeekDay4: Number(values.WeekDay4),
        WeekDay5: Number(values.WeekDay5),
        WeekDay6: Number(values.WeekDay6),
        WeekDay7: Number(values.WeekDay7),
        MonthDay1: Number(values.MonthDay1),
        MonthDay2: Number(values.MonthDay2),
        MonthDay3: Number(values.MonthDay3),
        MonthDay4: Number(values.MonthDay4),
        MonthDay5: Number(values.MonthDay5),
        MonthDay6: Number(values.MonthDay6),
        MonthDay7: Number(values.MonthDay7),
        MonthDay8: Number(values.MonthDay8),
        MonthDay9: Number(values.MonthDay9),
        MonthDay10: Number(values.MonthDay10),
        MonthDay11: Number(values.MonthDay11),
        MonthDay12: Number(values.MonthDay12),
        MonthDay13: Number(values.MonthDay13),
        MonthDay14: Number(values.MonthDay14),
        MonthDay15: Number(values.MonthDay15),
        MonthDay16: Number(values.MonthDay16),
        MonthDay17: Number(values.MonthDay17),
        MonthDay18: Number(values.MonthDay18),
        MonthDay19: Number(values.MonthDay19),
        MonthDay20: Number(values.MonthDay20),
        MonthDay21: Number(values.MonthDay21),
        MonthDay22: Number(values.MonthDay22),
        MonthDay23: Number(values.MonthDay23),
        MonthDay24: Number(values.MonthDay24),
        MonthDay25: Number(values.MonthDay25),
        MonthDay26: Number(values.MonthDay26),
        MonthDay27: Number(values.MonthDay27),
        MonthDay28: Number(values.MonthDay28),
        MonthDay29: Number(values.MonthDay29),
        MonthDay30: Number(values.MonthDay30),
        MonthDay31: Number(values.MonthDay31),
      },
    };
    console.log("🚀 ~ handleSaveButtonClick ~ idata:", idata);

    // return;
    try {
      const response = await dispatch(
        postData({
          accessID: "TR270",
          action: mode === "A" ? "insert" : "update",
          idata: idata,
        })
      );

      // Check response status for success
      if (response.payload.Status === "Y") {

        toast.success(response.payload.Msg); navigate(-1)
        const resData = response.payload.Data.detailData.map((value) => {
          return {
            ...value,
            DesignationID: {
              RecordID: value.DesignationID,
              Name: value.DesignationName,
            },
          };
        });
        setRows(resData);

      } else {
        toast.error(response.payload.Msg);
      }
    } catch (error) {
      console.error("Error saving rows:", error);
    }
  };

  const fnLogOut = (props) => {
    Swal.fire({
      title: errorMsgData.Warningmsg[props],
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: props,
    }).then((result) => {
      if (result.isConfirmed) {
        if (props === "Logout") {
          navigate("/");
        }
        if (props === "Close") {
          navigate(-1);
        }
      } else {
        return;
      }
    });
  };

  return (
    <React.Fragment>
      {getLoading ? <LinearProgress /> : false}
      <Paper elevation={3} sx={{ margin: "0px 10px", background: "#F2F0F0", height: "40px" }}>
        <Box display="flex" justifyContent="space-between" >
          <Box display="flex" borderRadius="3px" alignItems="center">
            {broken && !rtl && (
              <IconButton onClick={() => toggleSidebar()}>
                <MenuOutlinedIcon />
              </IconButton>
            )}
            <Breadcrumbs
              maxItems={2}
              aria-label="breadcrumb"
              separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
            >
              <Typography
                variant="h5"
                color="#0000D1"
                sx={{ cursor: "default", marginLeft: "10px" }}
                onClick={() => {
                  navigate("/Apps/TR276/Project");
                }}
              >
                {/* {`Project(${state.ProjectName})`} */}
                Project ({state.ProjectName})
              </Typography>

              <Typography
                variant="h5"
                color="#0000D1"
                sx={{ cursor: "default" }}
                onClick={() => navigate(-1)}
              >
                Routine Tasks
              </Typography>
              {/* <Typography
                variant="h5"
                color="#0000D1"
                sx={{ cursor: "default" }}
              >
                {mode === "E" ? "Edit" : "Add"}
              </Typography> */}
            </Breadcrumbs>
          </Box>

          <Box display="flex">
            <Tooltip title="Close">
              <IconButton onClick={() => fnLogOut("Close")} color="error">
                <ResetTvIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Logout">
              <IconButton color="error" onClick={() => fnLogOut("Logout")}>
                <LogoutOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Paper>

      <Paper elevation={3} sx={{ margin: "10px" }}>
        <Formik
          initialValues={InitialValue}
          onSubmit={(values, setSubmitting) => {
            setTimeout(() => {
              handleSaveButtonClick(values);
            }, 100);
          }}
          enableReinitialize={true}
          validationSchema={validationSchema}
        >
          {({
            errors,
            touched,
            handleBlur,
            handleChange,
            isSubmitting,
            values,
            handleSubmit,
            setFieldValue,
          }) => (
            <form onSubmit={handleSubmit}>
              <Box
                display="grid"
                gap={formGap}
                padding={1}
                gridTemplateColumns="repeat(2 , minMax(0,1fr))"
                // gap="30px"
                sx={{
                  "& > div": {
                    gridColumn: isNonMobile ? undefined : "span 2",
                  },
                }}
              >
                {CompanyAutoCode == "Y" ? (
                  <TextField
                    name="code"
                    type="text"
                    id="code"
                    label="Code"
                    placeholder="Auto"
                    variant="standard"
                    focused
                    //required
                    value={values.code}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.code && !!errors.code}
                    helperText={touched.code && errors.code}
                    // autoFocus
                    InputProps={{ readOnly: true }}
                  />
                ) : (
                  <TextField
                    name="code"
                    type="text"
                    id="code"
                    label={
                      <>
                        Code<span style={{ color: "red", fontSize: "20px" }}> * </span>
                      </>
                    }
                    variant="standard"
                    focused
                    // required
                    value={values.code}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.code && !!errors.code}
                    helperText={touched.code && errors.code}
                    autoFocus

                  />
                )}

                <TextField
                  name="name"
                  type="text"
                  id="name"
                  label="Description"
                  variant="standard"
                  focused
                  value={values.name}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  error={!!touched.name && !!errors.name}
                  helperText={touched.name && errors.name}
                  autoFocus={CompanyAutoCode == "Y"}
                />

                <Productautocomplete
                  sx={{ marginTop: "7px" }}
                  name="Milestone"
                  label="Milestone"
                  variant="outlined"
                  id="Milestone"
                  value={values.Milestone}
                  getOptionLabel={(option) => option?.Name || ""}
                  onChange={(newValue) => {
                    setFieldValue("Milestone", newValue);
                  }}
                  url={`${listViewurl}?data={"Query":{"AccessID":"2105","ScreenName":"Milestone","Filter":"ParentID=${params.filtertype}","Any":""}}`}
                />
                <Productautocomplete
                  sx={{ marginTop: "7px" }}
                  name="OperationStage"
                  label="Operation Stage"
                  variant="outlined"
                  id="OperationStage"
                  value={values.OperationStage}
                  onChange={(newValue) => {
                    setFieldValue("OperationStage", newValue);
                  }}
                  url={`${listViewurl}?data={"Query":{"AccessID":"2104","ScreenName":"Operation Stage","Filter":"parentID=${values.Milestone ? values.Milestone.RecordID : 0
                    }","Any":""}}`}
                />

                <Productautocomplete
                  name="Activities"
                  label="Activities"
                  variant="outlined"
                  id="Activities"
                  value={values.Activities}
                  onChange={(newValue) => {
                    setFieldValue("Activities", newValue);
                    console.log(newValue, "--newValue");
                    console.log(newValue.RecordID, "////");
                  }}
                  url={`${listViewurl}?data={"Query":{"AccessID":"2103","ScreenName":"Activities","Filter":"parentID=${values.OperationStage ? values.OperationStage.RecordID : 0
                    }","Any":""}}`}
                />

                <TextField
                  name="Comment"
                  type="text"
                  id="Comment"
                  label={
                    <>
                      Comment<span style={{ color: "red", fontSize: "20px" }}> * </span>
                    </>
                  }
                  multiline
                  rows={3}
                  variant="outlined"
                  fullWidth
                  focused
                  // required
                  value={values.Comment}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={!!touched.Comment && !!errors.Comment}
                  helperText={touched.Comment && errors.Comment}
                //sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  name="fromdate"
                  type="date"
                  id="fromdate"
                  label="From Date"
                  variant="standard"
                  focused
                  inputFormat="YYYY-MM-DD"
                  value={values.fromdate}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  error={!!touched.fromdate && !!errors.fromdate}
                  helperText={touched.fromdate && errors.fromdate}
                  sx={{ background: "" }}
                  InputLabelProps={{ shrink: true }}

                />
                <TextField
                  name="todate"
                  type="date"
                  id="todate"
                  label="To Date"
                  variant="standard"
                  focused
                  inputFormat="YYYY-MM-DD"
                  value={values.todate}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  error={!!touched.todate && !!errors.todate}
                  helperText={touched.todate && errors.todate}
                  sx={{ background: "" }}
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    inputProps: {
                      min: values.fromdate || undefined,
                      // max: values.fromdate
                      //   ? dayjs(values.fromdate)
                      //     .add(6, "day")
                      //     .format("YYYY-MM-DD")
                      //   : undefined,
                    },
                  }}
                />
                <Box>
                  <Field
                    //  size="small"
                    type="checkbox"
                    name="checkbox1"
                    id="checkbox1"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    as={Checkbox}
                    label="Weekend"
                  />

                  <FormLabel focused={false}>Include Weekend</FormLabel>
                  <Field
                    //  size="small"
                    type="checkbox"
                    name="checkbox2"
                    id="checkbox2"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    as={Checkbox}
                    label="Holiday"
                  />

                  <FormLabel focused={false}>Include Holiday</FormLabel>
                </Box>
              </Box>

              <Box
                m="5px"
                sx={{ display: "flex", flexDirection: "row", gap: 1 }}
              >
                {!getLoading ? (
                  <>
                    <Box
                      m="5px 0 0 0"
                      height="50vh"
                      flex={3}
                      sx={{
                        "& .MuiDataGrid-root": {
                          border: "none",
                        },
                        "& .MuiDataGrid-cell": {
                          borderBottom: "none",
                        },
                        "& .name-column--cell": {
                          color: colors.greenAccent[300],
                        },
                        "& .MuiDataGrid-columnHeaders": {
                          backgroundColor: colors.blueAccent[800],
                          borderBottom: "none",
                        },
                        "& .MuiDataGrid-virtualScroller": {
                          backgroundColor: colors.primary[400],
                        },
                        "& .MuiDataGrid-footerContainer": {
                          borderTop: "none",
                          backgroundColor: colors.blueAccent[800],
                        },
                        "& .MuiCheckbox-root": {
                          color: `${colors.greenAccent[200]} !important`,
                        },
                        "& .odd-row": {
                          backgroundColor: "",
                          color: "", // Color for odd rows
                        },
                        "& .even-row": {
                          backgroundColor: "#D3D3D3",
                          color: "", // Color for even rows
                        },
                      }}
                    >
                      <DataGrid
                        sx={{
                          "& .MuiDataGrid-footerContainer": {
                            height: dataGridHeaderFooterHeight,
                            minHeight: dataGridHeaderFooterHeight,
                          },
                        }}
                        rows={rows}
                        columns={columns}
                        loading={exploreLoading}
                        rowModesModel={rowModesModel}
                        getRowId={(row) => row.RoutineDetailID}
                        editMode="row"
                        disableRowSelectionOnClick
                        rowHeight={dataGridRowHeight}
                        headerHeight={dataGridHeaderFooterHeight}
                        experimentalFeatures={{ newEditingApi: true }}
                        onRowModesModelChange={handleRowModesModelChange}
                        onRowEditStop={handleRowEditStop}
                        processRowUpdate={processRowUpdate}
                        onProcessRowUpdateError={(error) => {
                          console.error(
                            "Row update validation failed:",
                            error.message
                          );

                          toast.error(error.message);
                        }}
                        components={{
                          Toolbar: EditToolbar,
                        }}
                        componentsProps={{
                          toolbar: { setRows, setRowModesModel },
                        }}
                        rowsPerPageOptions={[5, 10, 20]}
                        getRowClassName={(params) =>
                          params.indexRelativeToCurrentPage % 2 === 0
                            ? "odd-row"
                            : "even-row"
                        }
                        pagination
                      />
                    </Box>
                  </>
                ) : (
                  false
                )}

                {!getLoading && (
                  <>
                    <Box sx={{ flex: 1, marginTop: -1.5 }}>
                      {/* <Typography variant="h6" marginTop={3} marginBottom={-1}>
                        Configuration
                      </Typography> */}
                      {mode == "A" && (
                        <FormControl
                          fullWidth
                          //disabled={mode == "E" && values.Status != "AL" && values.Status != "RC"}
                          focused
                          variant="standard"
                        >
                          <InputLabel id="Configuration">
                            Routine Type
                          </InputLabel>
                          <Select
                            name="RoutineType"
                            id="RoutineType"
                            value={values.RoutineType}
                            onChange={handleChange}
                          >
                            <MenuItem value="Daily">Daily</MenuItem>
                            <MenuItem value="Weekly">Weekly</MenuItem>
                            <MenuItem value="Monthly">Monthly</MenuItem>
                            <MenuItem value="Quarterly">Quarterly</MenuItem>
                            <MenuItem value="HalfYearly">Half-yearly</MenuItem>
                            <MenuItem value="Yearly">Yearly</MenuItem>
                          </Select>
                        </FormControl>
                      )}

                      {mode == "E" && (
                        <TextField
                          name="RoutineType"
                          type="text"
                          id="RoutineType"
                          variant="standard"
                          focused
                          label="Routine Type"
                          size="small"
                          value={values.RoutineType}
                          fullWidth
                        />
                      )}

                      {values.RoutineType === "Daily" && (
                        <Box
                          sx={{
                            height: "50vh",
                            display: "flex",
                            flexDirection: "column",
                            gap: "5px",
                            marginTop: 2.5,
                            maxWidth: 400,
                          }}
                        >
                          {/* Daily */}
                          <ListItem
                            button
                            onClick={() => toggleSection("Daily")}
                            sx={{
                              backgroundColor: "#3fcccc",
                              //color: colors.greenAccent[300],
                              fontWeight: "bold",
                              "&:hover": { backgroundColor: "#3fcccc" },
                            }}
                          >
                            <ListItemText primary="Daily" />
                            <IconButton
                              edge="end"
                              size="small"
                              sx={{ color: "white" }}
                            >
                              {openSections["Daily"] ? (
                                <ExpandLess />
                              ) : (
                                <ExpandMore />
                              )}
                            </IconButton>
                          </ListItem>
                          <Collapse
                            in={openSections["Daily"]}
                            timeout="auto"
                            unmountOnExit
                          >
                            <Box
                              sx={{
                                maxHeight: 300,
                                minWidth: 150,
                                overflowY: "auto",
                                backgroundColor: "#fff",
                                px: 1,
                                pt: 1,
                              }}
                            >
                              <List disablePadding>
                                <ListItem
                                // dense
                                // button
                                // onClick={() =>
                                //   handleCheckboxChange("midnight")
                                // }
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    {/* <Checkbox
                                      checked={!!checkboxData["midnight"]}
                                      tabIndex={-1}
                                      disableRipple
                                    /> */}
                                    <Checkbox
                                      id="Hourse24"
                                      name="Hourse24"
                                      checked={values.Hourse24}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="00:00" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() => handleCheckboxChange("oneAM")}
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="Hourse1"
                                      name="Hourse1"
                                      checked={values.Hourse1}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="01:00" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() => handleCheckboxChange("twoAM")}
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="Hourse2"
                                      name="Hourse2"
                                      checked={values.Hourse2}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="02:00" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() =>
                                //   handleCheckboxChange("threeAM")
                                // }
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="Hourse3"
                                      name="Hourse3"
                                      checked={values.Hourse3}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="03:00" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() => handleCheckboxChange("fourAM")}
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="Hourse4"
                                      name="Hourse4"
                                      checked={values.Hourse4}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="04:00" />
                                </ListItem>
                                <ListItem
                                  dense
                                // button
                                // onClick={() => handleCheckboxChange("fiveAM")}
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="Hourse5"
                                      name="Hourse5"
                                      checked={values.Hourse5}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="05:00" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() => handleCheckboxChange("sixAM")}
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="Hourse6"
                                      name="Hourse6"
                                      checked={values.Hourse6}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="06:00" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() =>
                                //   handleCheckboxChange("sevenAM")
                                // }
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="Hourse7"
                                      name="Hourse7"
                                      checked={values.Hourse7}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="07:00" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() =>
                                //   handleCheckboxChange("eightAM")
                                // }
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="Hourse8"
                                      name="Hourse8"
                                      checked={values.Hourse8}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="08:00" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() => handleCheckboxChange("nineAM")}
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="Hourse9"
                                      name="Hourse9"
                                      checked={values.Hourse9}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="09:00" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() => handleCheckboxChange("tenAM")}
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="Hourse10"
                                      name="Hourse10"
                                      checked={values.Hourse10}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="10:00" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() =>
                                //   handleCheckboxChange("elevenAM")
                                // }
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="Hourse11"
                                      name="Hourse11"
                                      checked={values.Hourse11}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="11:00" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() =>
                                //   handleCheckboxChange("twelvePM")
                                // }
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="Hourse12"
                                      name="Hourse12"
                                      checked={values.Hourse12}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="12:00" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() =>
                                //   handleCheckboxChange("thirteenPM")
                                // }
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="Hourse13"
                                      name="Hourse13"
                                      checked={values.Hourse13}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="13:00" />
                                </ListItem>
                                <ListItem
                                //   dense
                                //   button
                                //   onClick={() =>
                                //     handleCheckboxChange("fourteenPM")
                                //   }
                                //   sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="Hourse14"
                                      name="Hourse14"
                                      checked={values.Hourse14}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="14:00" />
                                </ListItem>
                                <ListItem
                                //   dense
                                //   button
                                //   onClick={() =>
                                //     handleCheckboxChange("fifteenPM")
                                //   }
                                //   sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="Hourse15"
                                      name="Hourse15"
                                      checked={values.Hourse15}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="15:00" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() =>
                                //   handleCheckboxChange("sixteenPM")
                                // }
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="Hourse16"
                                      name="Hourse16"
                                      checked={values.Hourse16}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="16:00" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() =>
                                //   handleCheckboxChange("seventeenPM")
                                // }
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="Hourse17"
                                      name="Hourse17"
                                      checked={values.Hourse17}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="17:00" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() =>
                                //   handleCheckboxChange("eighteenPM")
                                // }
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="Hourse18"
                                      name="Hourse18"
                                      checked={values.Hourse18}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="18:00" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() =>
                                //   handleCheckboxChange("nineteenPM")
                                // }
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="Hourse19"
                                      name="Hourse19"
                                      checked={values.Hourse19}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="19:00" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() =>
                                //   handleCheckboxChange("twentyPM")
                                // }
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="Hourse20"
                                      name="Hourse20"
                                      checked={values.Hourse20}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="20:00" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() =>
                                //   handleCheckboxChange("twentyonePM")
                                // }
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="Hourse21"
                                      name="Hourse21"
                                      checked={values.Hourse21}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="21:00" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() =>
                                //   handleCheckboxChange("twentytwoPM")
                                // }
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="Hourse22"
                                      name="Hourse22"
                                      checked={values.Hourse22}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="22:00" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() =>
                                //   handleCheckboxChange("twentythreePM")
                                // }
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="Hourse23"
                                      name="Hourse23"
                                      checked={values.Hourse23}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="23:00" />
                                </ListItem>
                              </List>
                            </Box>
                          </Collapse>
                          <Divider />
                        </Box>
                      )}
                      {values.RoutineType === "Weekly" && (
                        <Box
                          sx={{
                            height: "50vh",
                            display: "flex",
                            flexDirection: "column",
                            gap: "5px",
                            marginTop: 2.5,
                            maxWidth: 400,
                          }}
                        >
                          {/* Weekly */}
                          <ListItem
                            button
                            onClick={() => toggleSection("Weekly")}
                            sx={{
                              backgroundColor: "#3fcccc",
                              //color: colors.greenAccent[300],
                              fontWeight: "bold",
                              "&:hover": { backgroundColor: "#3fcccc" },
                            }}
                          >
                            <ListItemText primary="Weekly" />
                            <IconButton
                              edge="end"
                              size="small"
                              sx={{ color: "white" }}
                            >
                              {openSections["Weekly"] ? (
                                <ExpandLess />
                              ) : (
                                <ExpandMore />
                              )}
                            </IconButton>
                          </ListItem>
                          <Collapse
                            in={openSections["Weekly"]}
                            timeout="auto"
                            unmountOnExit
                          >
                            <Box
                              sx={{
                                maxHeight: 300,
                                minWidth: 200,
                                overflowY: "auto",
                                backgroundColor: "#fff",
                                px: 1,
                                pt: 1,
                              }}
                            >
                              <List disablePadding>
                                <ListItem
                                // dense
                                // button
                                // onClick={() => handleCheckboxChange("sunday")}
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="WeekDay1"
                                      name="WeekDay1"
                                      checked={values.WeekDay1}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Sunday" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() => handleCheckboxChange("monday")}
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    {/* <Checkbox
                                      checked={!!checkboxData["monday"]}
                                      tabIndex={-1}
                                      disableRipple
                                    /> */}
                                    <Checkbox
                                      id="WeekDay2"
                                      name="WeekDay2"
                                      checked={values.WeekDay2}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Monday" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() =>
                                //   handleCheckboxChange("Tuesday")
                                // }
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="WeekDay3"
                                      name="WeekDay3"
                                      checked={values.WeekDay3}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Tuesday" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() =>
                                //   handleCheckboxChange("Wednesday")
                                // }
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="WeekDay4"
                                      name="WeekDay4"
                                      checked={values.WeekDay4}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Wednesday" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() =>
                                //   handleCheckboxChange("Thursday")
                                // }
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="WeekDay5"
                                      name="WeekDay5"
                                      checked={values.WeekDay5}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Thursday" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() => handleCheckboxChange("Friday")}
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="WeekDay6"
                                      name="WeekDay6"
                                      checked={values.WeekDay6}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Friday" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() =>
                                //   handleCheckboxChange("Saturday")
                                // }
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="WeekDay7"
                                      name="WeekDay7"
                                      checked={values.WeekDay7}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Saturday" />
                                </ListItem>
                              </List>
                            </Box>
                          </Collapse>
                          <Divider />
                        </Box>
                      )}
                      {(values.RoutineType === "Monthly" || values.RoutineType === "Quarterly" || values.RoutineType === "HalfYearly" || values.RoutineType === "Yearly") && (
                        <Box
                        
                          sx={{
                            height: "50vh",
                            display: "flex",
                            flexDirection: "column",
                            gap: "5px",
                            marginTop: 2.5,
                            maxWidth: 400,
                          }}
                        >
                          {/* Monthly */}
                          <ListItem
                            button
                            onClick={() => toggleSection("Monthly")}
                            sx={{
                              backgroundColor: "#3fcccc",
                              //color: colors.greenAccent[300],
                              fontWeight: "bold",
                              "&:hover": { backgroundColor: "#3fcccc" },
                            }}
                          >
                            <ListItemText primary="Monthly" />
                            <IconButton
                              edge="end"
                              size="small"
                              sx={{ color: "white" }}
                            >
                              {openSections["Monthly"] ? (
                                <ExpandLess />
                              ) : (
                                <ExpandMore />
                              )}
                            </IconButton>
                          </ListItem>
                          <Collapse
                            in={openSections["Monthly"]}
                            timeout="auto"
                            unmountOnExit
                          >
                            <Box
                              sx={{
                                maxHeight: 300,
                                minWidth: 150,
                                overflowY: "auto",
                                backgroundColor: "#fff",
                                px: 1,
                                pt: 1,
                              }}
                            >
                              <List disablePadding>
                                <ListItem
                                // dense
                                // button
                                // onClick={() => handleCheckboxChange("day1")}
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    {/* <Checkbox
                                      checked={!!checkboxData["day1"]}
                                      tabIndex={-1}
                                      disableRipple
                                    /> */}
                                    <Checkbox
                                      id="MonthDay1"
                                      name="MonthDay1"
                                      checked={values.MonthDay1}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Day 1" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() => handleCheckboxChange("day2")}
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="MonthDay2"
                                      name="MonthDay2"
                                      checked={values.MonthDay2}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Day 2" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() => handleCheckboxChange("day3")}
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="MonthDay3"
                                      name="MonthDay3"
                                      checked={values.MonthDay3}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Day 3" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() => handleCheckboxChange("day4")}
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="MonthDay4"
                                      name="MonthDay4"
                                      checked={values.MonthDay4}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Day 4" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() => handleCheckboxChange("day5")}
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="MonthDay5"
                                      name="MonthDay5"
                                      checked={values.MonthDay5}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Day 5" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() => handleCheckboxChange("day6")}
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="MonthDay6"
                                      name="MonthDay6"
                                      checked={values.MonthDay6}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Day 6" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() => handleCheckboxChange("day7")}
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="MonthDay7"
                                      name="MonthDay7"
                                      checked={values.MonthDay7}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Day 7" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() => handleCheckboxChange("day8")}
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="MonthDay8"
                                      name="MonthDay8"
                                      checked={values.MonthDay8}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Day 8" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() => handleCheckboxChange("day9")}
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="MonthDay9"
                                      name="MonthDay9"
                                      checked={values.MonthDay9}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Day 9" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() => handleCheckboxChange("day10")}
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="MonthDay10"
                                      name="MonthDay10"
                                      checked={values.MonthDay10}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Day 10" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() => handleCheckboxChange("day11")}
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="MonthDay11"
                                      name="MonthDay11"
                                      checked={values.MonthDay11}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Day 11" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() => handleCheckboxChange("day12")}
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="MonthDay12"
                                      name="MonthDay12"
                                      checked={values.MonthDay12}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Day 12" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() => handleCheckboxChange("day13")}
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="MonthDay13"
                                      name="MonthDay13"
                                      checked={values.MonthDay13}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Day 13" />
                                </ListItem>
                                <ListItem
                                //   dense
                                //   button
                                //   onClick={() => handleCheckboxChange("day14")}
                                //   sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="MonthDay14"
                                      name="MonthDay14"
                                      checked={values.MonthDay14}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Day 14" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() => handleCheckboxChange("day15")}
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="MonthDay15"
                                      name="MonthDay15"
                                      checked={values.MonthDay15}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Day 15" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() => handleCheckboxChange("day16")}
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="MonthDay16"
                                      name="MonthDay16"
                                      checked={values.MonthDay16}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Day 16" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() => handleCheckboxChange("day17")}
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="MonthDay17"
                                      name="MonthDay17"
                                      checked={values.MonthDay17}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Day 17" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() => handleCheckboxChange("day18")}
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="MonthDay18"
                                      name="MonthDay18"
                                      checked={values.MonthDay18}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Day 18" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() => handleCheckboxChange("day19")}
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="MonthDay19"
                                      name="MonthDay19"
                                      checked={values.MonthDay19}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Day 19" />
                                </ListItem>

                                <ListItem
                                // dense
                                // button
                                // onClick={() => handleCheckboxChange("day20")}
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="MonthDay20"
                                      name="MonthDay20"
                                      checked={values.MonthDay20}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Day 20" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() => handleCheckboxChange("day21")}
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="MonthDay21"
                                      name="MonthDay21"
                                      checked={values.MonthDay21}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Day 21" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() => handleCheckboxChange("day22")}
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="MonthDay22"
                                      name="MonthDay22"
                                      checked={values.MonthDay22}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Day 22" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() => handleCheckboxChange("day23")}
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="MonthDay23"
                                      name="MonthDay23"
                                      checked={values.MonthDay23}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Day 23" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() => handleCheckboxChange("day24")}
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="MonthDay24"
                                      name="MonthDay24"
                                      checked={values.MonthDay24}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Day 24" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() => handleCheckboxChange("day25")}
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="MonthDay25"
                                      name="MonthDay25"
                                      checked={values.MonthDay25}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Day 25" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() => handleCheckboxChange("day26")}
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="MonthDay26"
                                      name="MonthDay26"
                                      checked={values.MonthDay26}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Day 26" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() => handleCheckboxChange("day27")}
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="MonthDay27"
                                      name="MonthDay27"
                                      checked={values.MonthDay27}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Day 27" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() => handleCheckboxChange("day28")}
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="MonthDay28"
                                      name="MonthDay28"
                                      checked={values.MonthDay28}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Day 28" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() => handleCheckboxChange("day29")}
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="MonthDay29"
                                      name="MonthDay29"
                                      checked={values.MonthDay29}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Day 29" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() => handleCheckboxChange("day30")}
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="MonthDay30"
                                      name="MonthDay30"
                                      checked={values.MonthDay30}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Day 30" />
                                </ListItem>
                                <ListItem
                                // dense
                                // button
                                // onClick={() => handleCheckboxChange("day31")}
                                // sx={{ pl: 4 }}
                                >
                                  <ListItemIcon>
                                    <Checkbox
                                      id="MonthDay31"
                                      name="MonthDay31"
                                      checked={values.MonthDay31}
                                      tabIndex={-1}
                                      disableRipple
                                      onChange={handleChange}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary="Day 31" />
                                </ListItem>
                              </List>
                            </Box>
                          </Collapse>
                          <Divider />
                        </Box>
                      )}
                    </Box>
                  </>
                )}
              </Box>

              <Box display="flex" justifyContent="end" padding={1} gap="20px">
                {/* {mode === "E" ? (
                  <Box display="flex" alignItems="center" gap={1}>
                    <FileUploadIconButton onFileSelect={fileUpload} />
                  </Box>
                ) : null} */}

                <Button
                  color="secondary"
                  variant="contained"
                  // onClick={() => {
                  //   // handleSaveButtonClick(values);
                  // }}
                  type="submit"
                //disabled={true}
                >
                  Save
                </Button>
                {/* )} */}
                <Button
                  color="warning"
                  variant="contained"
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  Cancel
                </Button>
              </Box>
            </form>
          )}
        </Formik>
        <FileListPopup
          open={open}
          onClose={() => setOpen(false)}
          appId={recID}
          empId={EMPID}
        />
      </Paper>
      {mode === "E" && files.length > 0 ? (
        <Box mt={2}>
          <Paper elevation={3} sx={{ padding: 2 }}>
            {/* <Typography variant="h6" gutterBottom>
              Uploaded Files
            </Typography> */}
            <TableContainer component={Paper}>
              <Table size="small">
                <TableHead>
                  <TableRow sx={rowSx}>
                    <TableCell width={20}>
                      <strong>SL#</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Uploaded Date</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Filename</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Source</strong>
                    </TableCell>
                    <TableCell>
                      <strong>View</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {files.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={4} align="center">
                        No files uploaded yet.
                      </TableCell>
                    </TableRow>
                  ) : (
                    files.map((file, index) => (
                      <TableRow key={file.id || index} sx={rowSx}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{file.uploadedDate}</TableCell>
                        <TableCell>{file.filename}</TableCell>
                        <TableCell>{file.source}</TableCell>
                        <TableCell>
                          <Tooltip title="Open File">
                            <IconButton
                              color="primary"
                              component="a"
                              href={file.url}
                              target="_blank"
                              rel="noopener noreferrer"
                              size="small"
                            >
                              <OpenInNewIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Box>
      ) : null}
    </React.Fragment>
  );
};

export default EditRoutine;
